export default __webpack_public_path__ + "static/media/Business_Requests_3.4281eeb4.svg";